export class UnsavedObjectPopupObj {
    isNeedMethodEmit: boolean;
    methodName: string;
    methodArgs: Array<any>;
    moveToUrl: string;
    component: any;

    constructor() {
        this.isNeedMethodEmit = false;
        this.methodName = '';
        this.methodArgs = new Array<any>();
        this.moveToUrl = '';
        this.component = null;
    }
    
}